module.exports = __webpack_public_path__ + "img/10.52f35434.jpg";